import { createSelector } from 'reselect';
import { getSkipSetupParts } from './getSkipSetupParts';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getUnattendedOperatorPersonId } from './getUnattendedOperatorPersonId';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

/**
 * Whether submit work / sign out opens the zero-parts setup action modal
 * instead of the full labor ticket form. With setup parts skipped, that covers
 * setup tickets and open tickets owned by the shared Unattended operator. APM
 * submits Unattended tickets through its own flow, so it keeps the form.
 */
export const getUseSetupActionModal = createSelector(
  [
    getSkipSetupParts,
    getCurrentLaborTicket,
    getUnattendedOperatorPersonId,
    getIsApmERPJobFlow,
  ],
  (skipSetupParts, currentLaborTicket, unattendedPersonId, isApmERPJobFlow) => {
    if (!skipSetupParts || !currentLaborTicket) {
      return false;
    }
    if (currentLaborTicket.type?.toLowerCase() === 'setup') {
      return true;
    }
    return (
      !isApmERPJobFlow &&
      currentLaborTicket.state !== 'CLOSED' &&
      !!unattendedPersonId &&
      currentLaborTicket.personId === unattendedPersonId
    );
  }
);
